<script>
import features from '@app/assets/data/features.json';
import TalkizyLogoMark from '@shared/components/TalkizyLogoMark.vue';

export default {
  components: { TalkizyLogoMark },
  props: {
    hasCta: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      features,
    };
  },
};
</script>

<template>
  <div class="lfcomp">
    <p class="has-text-centered is-size-7 has-text-grey-dark mb-5 mx-auto" style="max-width: 760px;">
      <TalkizyLogoMark class="lfcomp_talkizy_logo mr-1" /> Avec votre abonnement Teachizy, profitez d'un <strong>accès Talkizy dédié</strong> : l'outil de visio pensé pour les formateurs et conçu pour fonctionner avec Teachizy. Hybridez vos formations sans quitter votre plateforme, avec une solution 100% française négociée pour vous.
    </p>
    <div class="columns">
    <div class="column">
      <RenderlessToggle #default="{ isActive, toggleActive }" :length="features.PERCENT.length + 1">
        <ul class="panel has-background-white" style="border-radius: 20px; overflow: hidden;">
          <li class="panel-block px-6 pt-6 pb-10">
            <div class="w-full">
              <h2 class="is-size-4 has-text-weight-bold w-full">
                <span class="is-block is-size-7 has-text-weight-normal">Forfait</span>
                DÉCOUVERTE
              </h2>
              <p class="w-full">
                <span class="mb-4 has-text-success">Gratuit</span>
                <br>
                <span class="mb-4 has-text-info">Sans engagement</span>
              </p>
            </div>
          </li>
          <li class="lfcomp_feature panel-block">
            <a class="lfcomp_feature_link w-full" href="#_talkizy_PERCENT" @click.prevent="toggleActive(features.PERCENT.length)">
              <span class="lfcomp_feature_name">
                <TalkizyLogoMark class="lfcomp_talkizy_logo is-size-6 mr-4" />
                <span><strong>Accès Talkizy inclus</strong></span>
              </span>
              <b-icon class="has-text-info is-size-8" icon="plus" />
            </a>
            <div
              v-show="isActive === features.PERCENT.length"
              id="_talkizy_PERCENT"
              class="mt-4 p-4 w-full has-background-light is-size-7"
            >
              <strong class="is-block mb-1">La visio pour démarrer</strong>
              Hybridez vos formations en connectant Teachizy et Talkizy : 3 participants par visio, 45 min, émargement sur 3 visios. Un outil 100% français, intégré à Teachizy.
            </div>
          </li>
          <li v-for="(f, i) in features.PERCENT" :key="i" class="lfcomp_feature panel-block">
            <a class="lfcomp_feature_link w-full" :href="`#_f${i}`" @click.prevent="toggleActive(i)">
              <span class="lfcomp_feature_name">
                <b-icon
                  class="is-size-6 mr-4"
                  :class="f.icon_color || (f.included ? 'has-text-primary' : 'has-text-danger')"
                  :icon="f.icon || (f.included ? 'check-circle' : 'times')"
                />
                <span v-html="f.text" />
              </span>
              <b-icon class="has-text-info is-size-8" icon="plus" />
            </a>
            <div
              v-show="isActive === i"
              :id="`_f${i}`"
              class="mt-4 p-4 w-full has-background-light is-size-7"
            >
              {{ f.description }}
            </div>
          </li>
          <li v-if="hasCta" class="panel-block p-6">
            <b-button tag="router-link" type="is-primary" size="is-medium" :to="{ name: 'plan', query: { onglet: 'vous' } }" outlined expanded>
              Démarrez gratuitement
            </b-button>
          </li>
        </ul>
      </RenderlessToggle>
    </div>
    <div class="column">
      <RenderlessToggle #default="{ isActive, toggleActive }" :length="features.PRO.length + 1">
        <ul class="panel has-background-white" style="border-radius: 20px; overflow: hidden;">
          <li class="panel-block p-6">
            <div class="w-full">
              <h2 class="is-size-4 has-text-weight-bold w-full">
                <span class="is-block is-size-7 has-text-weight-normal">Forfait</span>
                PRO
              </h2>
              <p class="w-full">
                <span class="mb-4 has-text-success">
                  <span class="is-size-4 has-text-weight-bold">
                    {{ $constants.PRICES.MONTHLY.PRO }} &euro;
                  </span> TTC / mois
                </span>
                ou
                <span class="mb-4 has-text-success">
                  <span class="is-size-4 has-text-weight-bold">
                    {{ $constants.PRICES.YEARLY.PRO }} &euro;
                  </span> TTC / an
                </span>
                <br>
                <span class="mb-4 has-text-info">Sans engagement</span>
              </p>
            </div>
          </li>
          <li class="lfcomp_feature panel-block">
            <a class="lfcomp_feature_link w-full" href="#_talkizy_PRO" @click.prevent="toggleActive(features.PRO.length)">
              <span class="lfcomp_feature_name">
                <TalkizyLogoMark class="lfcomp_talkizy_logo is-size-6 mr-4" />
                <span><strong>Accès Talkizy inclus</strong></span>
              </span>
              <b-icon class="has-text-info is-size-8" icon="plus" />
            </a>
            <div
              v-show="isActive === features.PRO.length"
              id="_talkizy_PRO"
              class="mt-4 p-4 w-full has-background-light is-size-7"
            >
              <strong class="is-block mb-1">Un Basique amélioré pour animer</strong>
              L'accès Talkizy de votre forfait Pro : 10 participants par visio, 2 h de session, 1 salle permanente, émargement sur 10 visios. Pensé pour les formateurs, conçu pour Teachizy.
            </div>
          </li>
          <li v-for="(f, i) in features.PRO" :key="i" class="lfcomp_feature panel-block">
            <a class="lfcomp_feature_link w-full" :href="`#_f${i}`" @click.prevent="toggleActive(i)">
              <span class="lfcomp_feature_name">
                <b-icon
                  class="is-size-6 mr-4"
                  :class="f.icon_color || (f.included ? 'has-text-primary' : 'has-text-danger')"
                  :icon="f.icon || (f.included ? 'check-circle' : 'times')"
                />
                <span v-html="f.text" />
              </span>
              <b-icon class="has-text-info is-size-8" icon="plus" />
            </a>
            <div
              v-show="isActive === i"
              :id="`_f${i}`"
              class="mt-4 p-4 w-full has-background-light is-size-7"
            >
              {{ f.description }}
            </div>
          </li>
          <li v-if="hasCta" class="panel-block p-6">
            <b-button tag="router-link" type="is-primary" size="is-medium" :to="{ name: 'plan', query: { onglet: 'vous' } }" expanded>
              Commencez dès maintenant
            </b-button>
          </li>
        </ul>
      </RenderlessToggle>
    </div>
    <div class="column">
      <RenderlessToggle #default="{ isActive, toggleActive }" :length="features.EXPERT.length + 1">
        <ul class="panel has-background-white" style="border-radius: 20px; overflow: hidden;">
          <li class="panel-block p-6">
            <div class="w-full">
              <h2 class="is-size-4 has-text-weight-bold w-full">
                <span class="is-block is-size-7 has-text-weight-normal">Forfait</span>
                EXPERT
              </h2>
              <p class="w-full">
                <span class="mb-4 has-text-success">
                  <span class="is-size-4 has-text-weight-bold">
                    {{ $constants.PRICES.MONTHLY.EXPERT }} &euro;
                  </span> TTC / mois
                  ou
                  <span class="mb-4 has-text-success">
                    <span class="is-size-4 has-text-weight-bold">
                      {{ $constants.PRICES.YEARLY.EXPERT }} &euro;
                    </span> TTC / an
                  </span>
                </span>
                <br>
                <span class="mb-4 has-text-info">Sans engagement</span>
              </p>
            </div>
          </li>
          <li class="lfcomp_feature panel-block">
            <a class="lfcomp_feature_link w-full" href="#_talkizy_EXPERT" @click.prevent="toggleActive(features.EXPERT.length)">
              <span class="lfcomp_feature_name">
                <TalkizyLogoMark class="lfcomp_talkizy_logo is-size-6 mr-4" />
                <span><strong>Accès Talkizy inclus</strong></span>
              </span>
              <b-icon class="has-text-info is-size-8" icon="plus" />
            </a>
            <div
              v-show="isActive === features.EXPERT.length"
              id="_talkizy_EXPERT"
              class="mt-4 p-4 w-full has-background-light is-size-7"
            >
              <strong class="is-block mb-1">Toutes les briques formation pro</strong>
              L'accès Talkizy de votre forfait Expert : webinaires jusqu'à 50 participants, transcription et résumé IA, émargement illimité et conformité Qualiopi, en plus des fonctions d'animation. La visio 100% française qui hybride vos formations.
            </div>
          </li>
          <li v-for="(f, i) in features.EXPERT" :key="i" class="lfcomp_feature panel-block">
            <a class="lfcomp_feature_link w-full" :href="`#_f${i}`" @click.prevent="toggleActive(i)">
              <span class="lfcomp_feature_name">
                <b-icon
                  class="is-size-6 mr-4"
                  :class="f.icon_color || (f.included ? 'has-text-primary' : 'has-text-danger')"
                  :icon="f.icon || (f.included ? 'check-circle' : 'times')"
                />
                <span v-html="f.text" />
              </span>
              <b-icon class="has-text-info is-size-8" icon="plus" />
            </a>
            <div
              v-show="isActive === i"
              :id="`_f${i}`"
              class="mt-4 p-4 w-full has-background-light is-size-7"
            >
              {{ f.description }}
            </div>
          </li>
          <li v-if="hasCta" class="panel-block p-6">
            <b-button tag="router-link" type="is-primary" size="is-medium" :to="{ name: 'plan', query: { onglet: 'vous' } }" expanded>
              Commencez dès maintenant
            </b-button>
          </li>
        </ul>
      </RenderlessToggle>
    </div>
    </div>
    <div v-if="!hasCta" class="has-text-centered mt-6">
      <b-button
        tag="router-link"
        :to="{ name: 'plan', query: { onglet: 'vous' } }"
        type="is-primary"
        size="is-medium"
      >
        Prendre un abonnement
      </b-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.lfcomp {
  &_talkizy_logo {
    color: #0bc5fd;
  }

  &_feature {
    flex-direction: column;

    &_link,
    &_name {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &_link {
      color: $theme_color_black;
      &:hover {
        color: $theme_color_primary_hover;
      }
    }
  }

  > .columns {
    @include mobile {
      display: flex;
      flex-direction: column-reverse;
    }
  }
}
</style>
